import { TooltipContent } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { TaskStatusIcon, taskDate, taskStatusTone } from '@/frontend/features/Fde/projectTaskPresentation'
import type { FdeCopy, ProjectTask } from '@/frontend/features/Fde/types'

interface Props {
  task: ProjectTask
  copy: FdeCopy
  overdue: boolean
  showStart?: boolean
}

export default function ProjectTaskTooltipContent({ task, copy, overdue, showStart = false }: Props) {
  const words = copy.management
  return (
    <TooltipContent side="top" sideOffset={8} className="max-w-72 p-3 text-left text-wrap">
      <p className="text-[10px] text-muted-foreground">{task.identifier}</p>
      <p className="mt-1 text-xs font-medium leading-5">{task.title}</p>
      <div
        className={cn(
          'mt-2 inline-flex items-center gap-1.5 rounded px-2 py-1 text-[11px]',
          taskStatusTone[task.status],
        )}
      >
        <TaskStatusIcon status={task.status} className="size-3" />
        {words.statuses[task.status]}
      </div>
      <dl className="mt-3 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1.5 text-[11px]">
        <dt className="text-muted-foreground">{words.task_priority}</dt>
        <dd>{words.priorities[task.priority]}</dd>
        {showStart && (
          <>
            <dt className="text-muted-foreground">{words.task_start_on}</dt>
            <dd>{task.start_on ? taskDate(task.start_on) : words.no_start_date}</dd>
          </>
        )}
        <dt className="text-muted-foreground">{words.task_due_on}</dt>
        <dd className={overdue ? 'text-destructive' : undefined}>
          {task.due_on ? taskDate(task.due_on) : words.no_due_date}
          {overdue && ` · ${words.calendar_overdue}`}
        </dd>
        <dt className="text-muted-foreground">{words.task_responsibles}</dt>
        <dd className="break-words">
          {task.assignees.map((person) => person.name).join(', ') || words.task_unassigned}
        </dd>
      </dl>
    </TooltipContent>
  )
}
